import { render, staticRenderFns } from "./ArchivedOrders.vue?vue&type=template&id=0dafcbdc&scoped=true&"
import script from "./ArchivedOrders.vue?vue&type=script&lang=js&"
export * from "./ArchivedOrders.vue?vue&type=script&lang=js&"
import style0 from "./ArchivedOrders.vue?vue&type=style&index=0&id=0dafcbdc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dafcbdc",
  null
  
)

export default component.exports